(() => {
  const isBrowsePage = () => Boolean(document.querySelector('#product-grid, .ww-department__products'));
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || !isBrowsePage() || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, location.origin);
    if (destination.origin !== location.origin || !destination.pathname.includes('/products/')) return;
    try {
      history.replaceState({ ...history.state, wwBrowse: { url: location.href, y: scrollY } }, '', location.href);
    } catch {}
  });
  window.addEventListener('pageshow', (event) => {
    if (event.persisted || !isBrowsePage()) return;
    const saved = history.state?.wwBrowse;
    const navigation = performance.getEntriesByType('navigation')[0];
    if (!saved || saved.url !== location.href || navigation?.type !== 'back_forward') return;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (Math.abs(scrollY - saved.y) > 8) window.scrollTo({ top: saved.y, behavior: 'instant' });
    }));
  });
})();
